import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = "https://parentaibackend-production.up.railway.app";

export default function InviteRedeem() {
  const [status, setStatus] = useState("Activating...");

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.split("?")[1] || "");
    const token = params.get("token");

    if (!token) {
      setStatus("Missing token.");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API_BASE}/beta/redeem`, { token });
        const sessionKey = res.data.session_key;
        localStorage.setItem("tofuBetaSessionKey", sessionKey);
        setStatus("Activated! Redirecting...");
        window.location.hash = "#/";
      } catch (e) {
        setStatus("Activation failed. Please request a new beta link.");
      }
    })();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2>{status}</h2>
    </div>
  );
}